import axios from "axios";
import { toast } from "react-toastify";
import { getToken, logout } from "./authService";
const JWT = require("jsonwebtoken");

export var devToolOption = false;
export var host = "";
export var truckFilePath = host + "AryabhattaTruckDoc/";
export var driverFilePath = host + "AryabhattaDriverDoc/";
export var siDocPath = host + "AryabhattaDriverDoc/";
export var devEnv = true;

const frontEndHost = window.location.hostname;

if (
  frontEndHost === "127.0.0.1" ||
  frontEndHost === "localhost" ||
  frontEndHost === "aryabhattadev.quloi.com"
) {
  host = "https://vizioapi.quloi.com/Aryabhattadev/";
  siDocPath = "https://vizio.atafreight.com/HoundCoreAPI_Development/SIDoc/";
  devEnv = true;
  devToolOption = true;
} else if (frontEndHost === "aryabhatta.quloi.com") {
  host = "https://vizioapi.quloi.com/ArybhattaLive/";
  devToolOption = false;
  siDocPath = "https://vizio.atafreight.com/HoundCoreAPI_Live/SIDoc/";
  devEnv = false;
}

var auth_token = "";

function setTokenInHeader(token) {
  auth_token = token;
}

function validateToken(getToken) {
  const token = JWT.decode(getToken);
  if (token.exp < new Date() / 1000) {
    logout();
  }
}

axios.interceptors.response.use(null, (error) => {
  if (error.response && error.response.status === 500) {
    toast.error("Please check internet connection..!!");
  } else if (error.response && error.response.status === 401) {
    logout();
  }
  return Promise.reject(error);
});

axios.interceptors.request.use(function (config) {
  if (auth_token) {
    validateToken(getToken());
    config.headers["Authorization"] = `Bearer ${auth_token}`;
    return config;
  }
  return config;
});

const http = {
  ...axios,
  setTokenInHeader,
  validateToken,
};

export default http;
